import Header from "./Header";
import Main from "./Main";
import Footer from "./Footer";

import "./App.css";

const App = () => (
  <div className="site">
    <Header />
    <Main />
    <Footer />
  </div>
);

export default App;
